export default function($) {
  var speed = 90;
  $('.menu-item-has-children > a').not('.mega-menu .sub-menu .menu-item-has-children > a').attr('aria-haspopup', 'menu').attr('aria-expanded', 'false');

  function closeActiveSiblings($li) {
    $li.siblings('.menu-item-has-children--active').each(function() {
      $(this).removeClass('menu-item-has-children--active').children('.sub-menu').slideUp(speed);
      $(this).children('a').first().attr('aria-expanded', 'false');
    });
  }

  $('.menu-item-has-children > a').click(function(event) {
    if (window.innerWidth >= 1024) {
      if ($(this).closest('.sub-menu').closest('.mega-menu').length) return;

      event.preventDefault();
      event.stopPropagation();

      const $parent = $(this).parent();
      const isActive = $parent.hasClass('menu-item-has-children--active');

      closeActiveSiblings($parent);

      const $subMenu = $parent.children('.sub-menu');
      if (isActive) {
        $subMenu.slideUp(speed);
        $parent.removeClass('menu-item-has-children--active');
      } else {
        const isMegaMenu = $parent.hasClass('mega-menu');
        const displayValue = isMegaMenu ? 'grid' : 'block';
        $subMenu.slideDown(speed, function() {
          $(this).css('display', displayValue);
          if (isMegaMenu) {
            $(this).find('.sub-menu').css('display', 'block');
          }
        });
        $parent.addClass('menu-item-has-children--active');
      }

      $(this).attr('aria-expanded', isActive ? 'false' : 'true');
    }
  });

  $('.menu-item-has-children').click(function(event) {
    if (window.innerWidth < 1024) {
      event.stopPropagation();
      const $li = $(this);
      const isActive = $li.hasClass('menu-item-has-children--active');

      closeActiveSiblings($li);

      $li.children('.sub-menu').slideToggle(speed);
      $li.toggleClass('menu-item-has-children--active');
      $li.children('a').first().attr('aria-expanded', isActive ? 'false' : 'true');
    }
  });

  $('.nav').click(function(event) {
    if (window.innerWidth >= 1024) {
      event.stopPropagation();
    }
  });

  $(document).click(function(event) {
    if (window.innerWidth >= 1024) {
      if ($('.sub-menu').is(':visible')) {
        $('.sub-menu').slideUp(speed);
        $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
        $('.menu-item-has-children a').attr('aria-expanded', 'false');
      }
    } else {
      if (!$(event.target).closest('.js-nav, .js-nav-mobile-menu').length) {
        if ($('.sub-menu').is(':visible')) {
          $('.sub-menu').slideUp(speed);
          $('.menu-item-has-children--active').removeClass('menu-item-has-children--active');
          $('.menu-item-has-children a').attr('aria-expanded', 'false');
        }
      }
    }
  });

  $(window).scroll(function() {
    if ($(this).scrollTop() >= 100) {
      $('.js-backtotop').fadeIn();
    } else {
      $('.js-backtotop').fadeOut();
    }
  });
}
